import React from "react";

import Page from "../Page";
import girlWithLabel from "img/girl_with_label.png";

export default function Login({
  onStoreNumberChange,
  storeNumber,
  onStartClick,
  isStoreNumberValid,
  loading,
  history
}) {
  return (
    <Page>
      <div className="login-page">
        <div className="login-page__main-section">
          <img
            className="login-page__girl-with-label"
            src={girlWithLabel}
            alt=""
          />

          <div className="login-page__start-block">
            <p className="login-page__arms-text">
              Can you get your <span className="red">ARMS</span> around the pick
              ticket process from beginning to end?
            </p>

            <div className="input-row">
              <input
              autoComplete="off"
              onChange={onStoreNumberChange}
              name="storeNumber"
              value={storeNumber}
              className="login-page__store-input"
              required
              placeholder="Store Number"
              type="number"
              pattern="[0-9]*"
              inputMode="numeric"
              />

              {loading && <div className="loader"></div>}
            </div>

            {!isStoreNumberValid && (
              <p className="red">Please enter a valid store number.</p>
            )}

            <a
              href="#"
              className="btn login-page__start-btn"
              onClick={e => onStartClick(e, history)}
            >
              <span>Start</span>
            </a>
          </div>
        </div>
      </div>
    </Page>
  );
}
